import {
  SET_CAPTURE_SELECTION, SET_CAPTURE_SELECTIONS, SET_CAPTURE_MODAL_STATUS,
  SET_FILTER, SET_SETTINGS_MODAL_STATUS, SET_FILTER_MODAL_STATUS, SET_PRINTER_MODAL_STATUS,
  SET_PRINT_CAPTURES, SET_SHARE_MODAL_STATUS, SET_SELECTED_VIOLATION_ID, SET_PAGE, SET_PAGE_CAPTURE_LIMIT, SET_PAGE_CHANGED,
  SET_SEARCH_MODAL_STATUS, SET_VIEW, SET_CAPTURES_RENDERED, SET_SCROLL_STATUS, SET_SELECTED_VIOLATION_KEY_NUMBER,
  SET_MY_SCHOOLS_STATUS, SET_ALL_CHECKED, SET_PAGE_VIEW, SET_REPORTS_MODAL_STATUS, SET_GROUP_INDEX,
  SET_DEFAULT_REPORT, SET_DEFAULT_REPORT_SET, SET_DEFAULT_PAGE, SET_DEFAULT_VIEW, SET_DEFAULT_CAPTURE_COUNT,
  SET_FROM_VIEW, SET_FLAGGED_ONLY, SET_STATUS_SNACK, SET_AWAIT_TRIGGER, SET_TRIGGER_FILTER, SET_FROM_LINK, SET_REPORT, SET_PAGE_TYPE,
  SET_CAPTURES_EXHAUSTED,
  SET_END_OF_LINK,
  SET_NEED_FILTER,
  SET_FROM_URL,
  SET_TEMPORARY_QUARANTINE_VIEW,
  SET_EXPORT_MODAL_STATUS,
  LOGOUT
} from '../types'

import { defaultFilter } from '../../utils/variables'

const initialState = {
  SelectedViolationId: 0,
  SelectedCapture: null,
  SelectedCaptures: [],
  CapturesRendered: 0,
  PrintCaptures: [],
  SelectedViolationKeyNumber: 0,
  Filter: { ...defaultFilter },
  View: '',
  PageView: '',
  Report: 'users',
  Page: null,
  PageCaptureLimit: null,
  ScrollStatus: false,
  PageChanged: false,
  AllChecked: false,
  PageType: null,
  CapturesExhausted: false,
  EndOfLink: false,
  NeedFilter: false,

  CaptureModal: false,
  SettingsModal: false,
  ReportsModal: false,
  FilterModal: false,
  PrinterModal: false,
  ExportModal: false,
  ShareModal: false,
  SearchModal: false,
  MySchoolsModal: false,

  GroupIndex: 0,
  setFlaggedOnly: false,
  SnackShow: false,
  TriggerFilter: false,
  AwaitTrigger: false,
  FromLink: false,

  defaultReportSet: false,
  fromView: '',
  fromUrl: {},

  temporaryQuarantineView: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOGOUT: return {
      ...state,
      ...initialState
    }
    case SET_SELECTED_VIOLATION_ID: return {
      ...state,
      SelectedViolationId: action.payload
    }
    case SET_SELECTED_VIOLATION_KEY_NUMBER: return {
      ...state,
      SelectedViolationKeyNumber: action.payload
    }
    case SET_CAPTURE_SELECTION: return {
      ...state,
      SelectedCapture: action.payload
    }
    case SET_CAPTURE_SELECTIONS: return {
      ...state,
      SelectedCaptures: action.payload
    }
    case SET_PRINT_CAPTURES: return {
      ...state,
      PrintCaptures: action.payload
    }
    case SET_FILTER: return {
      ...state,
      Filter: action.payload
    }
    case SET_VIEW: return {
      ...state,
      View: action.payload
    }
    case SET_PAGE_VIEW: return {
      ...state,
      PageView: action.payload
    }
    case SET_CAPTURE_MODAL_STATUS: return {
      ...state,
      CaptureModal: action.payload
    }
    case SET_SETTINGS_MODAL_STATUS: return {
      ...state,
      SettingsModal: action.payload
    }
    case SET_REPORTS_MODAL_STATUS: return {
      ...state,
      ReportsModal: action.payload
    }
    case SET_FILTER_MODAL_STATUS: return {
      ...state,
      FilterModal: action.payload
    }
    case SET_PRINTER_MODAL_STATUS: return {
      ...state,
      PrinterModal: action.payload
    }
    case SET_SHARE_MODAL_STATUS: return {
      ...state,
      ShareModal: action.payload
    }
    case SET_SEARCH_MODAL_STATUS: return {
      ...state,
      SearchModal: action.payload
    }
    case SET_PAGE: return {
      ...state,
      Page: action.payload
    }
    case SET_PAGE_CHANGED: return {
      ...state,
      PageChanged: action.payload
    }
    case SET_ALL_CHECKED: return {
      ...state,
      AllChecked: action.payload
    }
    case SET_PAGE_CAPTURE_LIMIT: return {
      ...state,
      PageCaptureLimit: action.payload
    }
    case SET_CAPTURES_RENDERED: return {
      ...state,
      CapturesRendered: action.payload
    }
    case SET_SCROLL_STATUS: return {
      ...state,
      ScrollStatus: action.payload
    }
    case SET_MY_SCHOOLS_STATUS: return {
      ...state,
      MySchoolsModal: action.payload
    }
    case SET_GROUP_INDEX: return {
      ...state,
      GroupIndex: action.payload
    }
    case SET_TRIGGER_FILTER: return {
      ...state,
      TriggerFilter: action.payload
    }
    case SET_AWAIT_TRIGGER: return {
      ...state,
      AwaitTrigger: action.payload
    }
    case SET_STATUS_SNACK: return {
      ...state,
      SnackShow: action.payload
    }
    case SET_FROM_LINK: return {
      ...state,
      FromLink: action.payload
    }
    case SET_FLAGGED_ONLY: return {
      ...state,
      setFlaggedOnly: action.payload
    }
    case SET_DEFAULT_REPORT: return {
      ...state,
      Filter: action.payload
    }
    case SET_DEFAULT_PAGE: return {
      ...state,
      PageView: action.payload
    }
    case SET_DEFAULT_VIEW: return {
      ...state,
      View: action.payload
    }
    case SET_DEFAULT_CAPTURE_COUNT: return {
      ...state,
      Filter: action.payload
    }
    case SET_DEFAULT_REPORT_SET: return {
      ...state,
      defaultReportSet: action.payload
    }
    case SET_FROM_VIEW: return {
      ...state,
      fromView: action.payload
    }
    case SET_REPORT: return {
      ...state,
      Report: action.payload
    }
    case SET_PAGE_TYPE: return {
      ...state,
      PageType: action.payload
    }
    case SET_CAPTURES_EXHAUSTED: return {
      ...state,
      CapturesExhausted: action.payload
    }
    case SET_END_OF_LINK: return {
      ...state,
      EndOfLink: action.payload
    }
    case SET_NEED_FILTER: return {
      ...state,
      NeedFilter: action.payload
    }
    case SET_FROM_URL: return {
      ...state,
      fromUrl: action.payload
    }
    case SET_TEMPORARY_QUARANTINE_VIEW: return {
      ...state,
      temporaryQuarantineView: action.payload
    }
    case SET_EXPORT_MODAL_STATUS: return {
      ...state,
      ExportModal: action.payload
    }
    default: return { ...state }
  }
}
